module.exports = __webpack_public_path__ + "components/country-flag/static/cw-ec73350d17e4d0d22b81a5bf4802a0aa.svg";